import { useSearchParams } from "react-router-dom";

import { MINT_BASE_URL, MINT_URL } from "~config";

const useReferral = () => {
  const [searchParams] = useSearchParams();

  const referrerParam = (referrer?: string | null) =>
    referrer ? `?referrer=${referrer}` : "";

  const mintUrlWithReferrer = (
    collectionId: string,
    referrer?: string | null
  ) => {
    const mintUrl = `${MINT_BASE_URL}${MINT_URL.tokens.mint.replace(
      ":collectionId",
      collectionId
    )}`;
    return `${mintUrl}${referrerParam(referrer)}`;
  };

  const referrerQueryParamValue = searchParams.get("referrer") || undefined;

  return {
    referrerQueryParamValue,
    mintUrlWithReferrer,
  };
};

export default useReferral;
